//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEVICE } from "../../../store/mutation-types";

export default {
  name: "RichModalComponent",
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      // 标题栏
      type: String,
      default: "",
    },
    buttonText: {
      // 按钮文案
      type: String,
      default: "",
    },
    showBackBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isIos() {
      return this.$store.getters[DEVICE] === "ios";
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  methods: {
    /**
     * 打开instagram
     */
    btnClick() {
      this.$emit("btn-click");
    },
    /**
     * 关闭按钮点击事件
     */
    close() {
      this.$emit("close");
    },
    /**
     * 返回按钮点击事件
     */
    back() {
      this.$emit("back");
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/send_code/RichModal.vue